// import React from "react";

// // Replace these image paths with your actual icon file paths
// const features = [
//   {
//     image: "assets/images/icons/pickup-drop.png", // example: public/assets/images/icons/pickup-drop.png
//     title: "Free Pick Up & Drop",
//     text: "Your convenience matters. Complimentary pick-up and drop-off service for your vehicle — a stress-free experience.",
//   },
//   {
//     image: "assets/images/icons/roadside-support.png",
//     title: "24/7 Road Assistant",
//     text: "No matter the time or place, our 24/7 roadside assistance ensures you're never stranded. Drive confidently with support.",
//   },
//   {
//     image: "assets/images/icons/clean-rides.png",
//     title: "Clean & Comfortable Rides",
//     text: "Travel in style with well-sanitized, air-conditioned cabs and experienced drivers focused on your comfort.",
//   },
// ];

// const WhyChooseUsSection = () => {
//   return (
//     <section className="why-chooseus-section pt_120 pb_90">
//       <div className="container">
//         <div className="row align-items-center">
//           {/* Left Column — Section Title */}
//           <div className="col-xl-4 col-lg-4 col-md-12 col-sm-12">
//             <div className="section-title mb_60">
//               <span className="sub-title">WHY SAI TRUPTI CABS?</span>
//               <h2 className="title">
//                 Reliable, Comfortable, And Always On Time – Travel With Confidence
//               </h2>
//               <p className="why-chooseus-description">
//                 Sai Trupti Cabs is your go-to partner for safe, punctual, and
//                 affordable travel across Maharashtra. Trusted by thousands for
//                 city rides, outstation trips, and airport transfers.
//               </p>
//             </div>
//           </div>

//           {/* Right Columns — Features */}
//           {features.map((item, index) => (
//             <div
//               className="col-xl-4 col-lg-4 col-md-6 col-sm-12"
//               key={index}
//             >
//               <div className="why-chooseus-block yellow-bg">
//                 <div className="why-chooseus-icon">
//                   <img src={item.image} alt={item.title} />
//                 </div>
//                 <h5 className="why-chooseus-title">{item.title}</h5>
//                 <p className="why-chooseus-text">{item.text}</p>
//               </div>
//             </div>
//           ))}
//         </div>
//       </div>
//     </section>
//   );
// };

// export default WhyChooseUsSection;


import React from "react";

const features = [
  {
    icon: "icon-27",
    title: "24/7 Roadside Support",
    text: "Day or night, we’re here for you. Get help anytime with our dependable 24/7 customer and vehicle support.",
  },
  {
    icon: "icon-49",
    title: "Clean & Comfortable Rides",
    text: "Travel in style with well-sanitized, air-conditioned cabs and experienced drivers focused on your comfort.",
  },
];

const WhyChooseUsSection = () => {
  return (
    <section className="why-chooseus-section pt_120 pb_90">
      <div className="container">
        <div className="row align-items-center">
          {/* Left Column — Title and Description */}
          <div className="col-xl-6 col-lg-6 col-md-12 col-sm-12">
            <div className="section-title mb_60">
              <span className="sub-title">WHY SAI TRUPTI CABS?</span>
              <h2 className="title">
                Reliable, Comfortable, And Always On Time – Travel With
                Confidence
              </h2>
              <p className="why-chooseus-description">
                Sai Trupti Cabs is your go-to partner for safe, punctual, and
                affordable travel across Maharashtra. Trusted by thousands for
                city rides, outstation trips, and airport transfers.
              </p>
            </div>
          </div>

          {/* Right Column — Feature Boxes */}
          <div className="col-xl-6 col-lg-6 col-md-12 col-sm-12">
            <div className="row">
              {features.map((item, index) => (
                <div
                  className="col-md-6 col-sm-12 mb-4"
                  key={index}
                >
                  <div className="why-chooseus-block yellow-bg">
                    <div className="why-chooseus-icon">
                      <i className={item.icon}></i>
                    </div>
                    <h5 className="why-chooseus-title">{item.title}</h5>
                    <p className="why-chooseus-text">{item.text}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUsSection;
